import { render, staticRenderFns } from "./CodeDiff.vue?vue&type=template&id=4d7fd914&"
import script from "./CodeDiff.vue?vue&type=script&lang=js&"
export * from "./CodeDiff.vue?vue&type=script&lang=js&"
import style0 from "./CodeDiff.vue?vue&type=style&index=0&id=4d7fd914&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports